import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  detectablesStudentsListIsLoadingSelector,
} from 'redux/selectors'

import DialogBox from 'components/dialog-box'
import SearchableSelectField from 'components/searchable-select-field'
import { Button, Col, Icon, Row, TextInput, Table } from 'elements'

import { getAttendanceRate } from 'pages/attendance/helpers'
import { createStructuredSelector } from "reselect";

const mapObject = (objectArray, keyField, dataField) =>
  objectArray.reduce((objectSoFar, newObject) => {
    objectSoFar[`${newObject[keyField]}`] = newObject[dataField]
    return objectSoFar
  }, {})

export class CommittersList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      addCommitterDialogVisible: false,
      search: ''
    }
  }

  handleAddCommitterClick = () => {
    this.setState({
      addCommitterDialogVisible: true
    })
  }

  handleCommitterDialogAdd = () => {
    this.setState({
      addCommitterDialogVisible: false
    })
    // console.log(`Would have invoked API to add ${this.state.addCommitterSelectedKey}.`)
  }

  handleCommitterDialogCancel = () => {
    this.setState({
      addCommitterDialogVisible: false
    })
  }

  handleSearchChange = (event) => {
    this.setState({
      search: event.target.value.toLowerCase()
    })
  }

  handleCommitterClear = () => {
    this.setState({
      addCommitterSelectedKey: null
    })
  }

  handleCommitterSelect = (key) => {
    this.setState({
      addCommitterSelectedKey: key
    })
  }

  handlePrint = () => {
    window.print()
  }

  columns = () => {
    const { scheduleId } = this.props
    return [
      {
        title: "Student",
        dataIndex: "name",
        render: (text, record) =>(
          <Link to={`/attendance/schedules/${scheduleId}/${record.clientReference}`}>{record.name}</Link>
        )
      },
      {
        title: "ID",
        dataIndex: "clientReference",
        className: 'text-right',
      },
      {
        title: "Present",
        dataIndex: "presentCount",
        className: 'text-right',
      },
      {
        title: "Absent",
        dataIndex: "absentCount",
        className: 'text-right',
      },
      {
        title: "Attendance",
        className: 'text-right',
        key: 'rate',
        render: (text, record)=> `${getAttendanceRate(record)}%`
      }
    ]
  }

  render() {
    const { contactAttendance, scheduleId, loading } = this.props
    const committerMap = mapObject(
      contactAttendance.attendance || [],
      'clientReference',
      'name')
    const filteredStudents = contactAttendance.attendance.filter((c) => c.name.toLowerCase().indexOf(this.state.search) > -1)
    const numStudents = filteredStudents.length

    return (
      <div className="committers">
        {this.state.addCommitterDialogVisible &&
          <DialogBox>
            <h1>Add a student</h1>
            <SearchableSelectField
              inputId="committerSearch"
              inputClassName="unifi-input"
              data={committerMap}
              onItemSelect={this.handleCommitterSelect}
              onSelectionClear={this.handleCommitterClear}
            />
            <div className="buttons">
              <Button
                className="unifi-button primary"
                disabled={this.addCommitterSelectedKey ? "disabled" : ""}
                onClick={this.handleCommitterDialogAdd}
              >
                Add
              </Button>
              <Button
                className="unifi-button"
                onClick={this.handleCommitterDialogCancel}
              >
                Cancel
              </Button>
            </div>
          </DialogBox>
        }
        <div className="controls no-print">
          <TextInput className="unifi-input" type="text" placeholder="Search" onChange={this.handleSearchChange} />
          <Button className="addCommitter" onClick={this.handleAddCommitterClick}>
            <Icon type="plus-circle-o" /> Add a student
          </Button>
        </div>
        <div className="views">
          <Row type="flex" justify="center" align="middle">
            <Col sm={20}>
              <p>Showing {numStudents} students</p>
            </Col>
            <Col sm={4} className="text-right">
              <Button className="no-print" onClick={this.handlePrint}>Print</Button>
            </Col>
          </Row>
        </div>
        <Table
          className={'unifi-table'}
          dataSource={filteredStudents}
          columns={this.columns()}
          pagination={false}
          rowKey={record => record.clientReference}
          loading={loading}
        />
      </div>
    )
  }
}

export const selector = createStructuredSelector({
  loading: detectablesStudentsListIsLoadingSelector,
})

export default connect(selector)(CommittersList)



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-schedule-detail/components/committers-list/index.js